import { render, staticRenderFns } from "./BtSftpAndPgp.vue?vue&type=template&id=1df415e8&scoped=true&"
import script from "./BtSftpAndPgp.vue?vue&type=script&lang=js&"
export * from "./BtSftpAndPgp.vue?vue&type=script&lang=js&"
import style0 from "./BtSftpAndPgp.vue?vue&type=style&index=0&id=1df415e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df415e8",
  null
  
)

export default component.exports